"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCitationModalDialogStyle;
function createCitationModalDialogStyle() {
  return {
    '&.webchat__citation-modal-dialog': {
      '& .webchat__citation-modal-dialog__body': {
        lineHeight: '20px'
      }
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVDaXRhdGlvbk1vZGFsRGlhbG9nU3R5bGUiLCJsaW5lSGVpZ2h0Il0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvU3R5bGVzL1N0eWxlU2V0L0NpdGF0aW9uTW9kYWxEaWFsb2cudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY3JlYXRlQ2l0YXRpb25Nb2RhbERpYWxvZ1N0eWxlKCkge1xuICByZXR1cm4ge1xuICAgICcmLndlYmNoYXRfX2NpdGF0aW9uLW1vZGFsLWRpYWxvZyc6IHtcbiAgICAgICcmIC53ZWJjaGF0X19jaXRhdGlvbi1tb2RhbC1kaWFsb2dfX2JvZHknOiB7XG4gICAgICAgIGxpbmVIZWlnaHQ6ICcyMHB4J1xuICAgICAgfVxuICAgIH1cbiAgfTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQWUsU0FBU0EsOEJBQThCQSxDQUFBLEVBQUc7RUFDdkQsT0FBTztJQUNMLGtDQUFrQyxFQUFFO01BQ2xDLHlDQUF5QyxFQUFFO1FBQ3pDQyxVQUFVLEVBQUU7TUFDZDtJQUNGO0VBQ0YsQ0FBQztBQUNIIn0=